import React from 'react';
import { Header } from '../../../components';
import { WebSocketTestPanel } from '../../../components';

function WebSocketTestPage() {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Testing" title="WebSocket Test" />
      <WebSocketTestPanel />
    </div>
  );
}

export default WebSocketTestPage; 